export function dlTrackSubscriptionSubmit(gender) {
  window.dataLayer.push({
    event: 'visitor interaction',
    interaction_name: 'newsletter sign up',
    newsletter_type: gender,
  });
}
